import {
  DocumentGroup,
  UploadedDocumentInfoDocumentType,
} from '@urbanx/agx.campaigns.client'

export const agreementDocumentTypes: UploadedDocumentInfoDocumentType[] = [
  UploadedDocumentInfoDocumentType.Miscellaneous,
  UploadedDocumentInfoDocumentType.AgencyAgreement,
  UploadedDocumentInfoDocumentType.MarketingAgreement,
  UploadedDocumentInfoDocumentType.TitleSearch,
  UploadedDocumentInfoDocumentType.BodyCorporateDisclosureStatement,
  UploadedDocumentInfoDocumentType.PoolCertificate,
  UploadedDocumentInfoDocumentType.NoticeOfMultipleOffers,
  UploadedDocumentInfoDocumentType.NoPoolCertificate,
  UploadedDocumentInfoDocumentType.AppointmentOfRealEstateAgent,
  UploadedDocumentInfoDocumentType.IntentToSell,
  UploadedDocumentInfoDocumentType.PowerOfAttorney,
  UploadedDocumentInfoDocumentType.WaiverOfCoolingOff,
  UploadedDocumentInfoDocumentType.MaterialFact,
  UploadedDocumentInfoDocumentType.ProofOfIdentity,
  UploadedDocumentInfoDocumentType.AgencyAgreementAnnexure,
  UploadedDocumentInfoDocumentType.ConsumerGuide,
  UploadedDocumentInfoDocumentType.OwnerBuilderDeclaration,
  UploadedDocumentInfoDocumentType.AdditionalAnnexure,
  UploadedDocumentInfoDocumentType.ComparativeMarketAnalysis,
  UploadedDocumentInfoDocumentType.BuildingCertificate,
  UploadedDocumentInfoDocumentType.SurveyPlan,
  UploadedDocumentInfoDocumentType.SellerDisclosure,
  UploadedDocumentInfoDocumentType.BodyCorporateCertificate,
  UploadedDocumentInfoDocumentType.CommunityManagementStatement,
  UploadedDocumentInfoDocumentType.DisclosureInstructions,
]

export const filterDocumentGroups = (
  groups: DocumentGroup[] = []
): DocumentGroup[] => {
  return groups
    .map((group) => ({
      ...group,
      documents:
        group.documents?.filter(
          (doc) =>
            doc.documentType &&
            agreementDocumentTypes.includes(doc.documentType)
        ) ?? [],
    }))
    .filter((group) => group.documents.length > 0)
}
